export default __webpack_public_path__ + "static/media/Pretendard-Thin.41861ab4.woff2";